import React from "react";
class About extends React.Component {
  render() {
    return (
      <main>
        <div className="mainBody">
          <div className="bannerBlock1">
            <div
              style={{
                position: "absolute",
                right: "0px",
                width: "250px",
                height: "155px",
                backgroundimage: "url(images/globe.png)",
                backgroundposition: "-0px -40px",
              }}
            ></div>
            <div className="bannerContent">
              <div className="content">
                <span className="pageTitle">ABOUT US</span>
                <br />
                <span className="subTitle">
                <b>sariT͟Həm!</b> where innovators meet the talent ... {" "}
                  <br />
                  Trust, Time, Talent and Innovation are essential to business.  Let's treat them with respect.
                </span>
              </div>
            </div>
          </div>
          <div className="content padSmall">
            <p>
              <b>sariT͟Həm</b> is a technology solutions company that bridges the gap between innovation and talent. 
              We are more than technical recruiters—we are partners in building cutting-edge solutions using the latest 
              technologies including <b>Artificial Intelligence (AI)</b>, <b>Machine Learning</b>, <b>Cloud Computing</b>, 
              and modern software development practices.
            </p>
            <p>
              Our expertise spans across <b>AI/ML Engineering</b>, <b>Cloud Infrastructure</b> (AWS, GCP, Azure), 
              <b> Kubernetes and Container Orchestration</b>, <b>Serverless Architecture</b>, <b>DevOps/CI/CD</b>, 
              <b> Infrastructure as Code</b>, and <b>Full-Stack Development</b>. We leverage technologies like 
              <b> Natural Language Processing (NLP)</b>, <b>Large Language Models (LLMs)</b>, <b>React Native</b>, 
              <b> Terraform</b>, and modern cloud-native tools to deliver scalable, cost-effective solutions.
            </p>
            <p>
              Since 2019, we have placed <b>200+ technical resources</b> including AI/ML Ops Engineers, Cloud Architects, 
              Full-Stack Developers, and DevOps specialists. Our global technical team works around the clock, enabling 
              your organization to focus on innovation while we handle talent acquisition and solution development.
            </p>
            <p>
              We have delivered <b>20+ projects</b> across various domains including application modernization, 
              cloud migrations, multi-region network architecture, AI-powered applications, and serverless infrastructure. 
              Our solutions have helped organizations reduce costs, improve efficiency, and accelerate time-to-market.
            </p>
            <p>
              <b>Trust, Time, Talent, and Innovation</b> are essential to business. We treat them with respect. 
              We believe trust and open communication are the keys to success in any business relationship. 
              A deep understanding of your project, well-defined requirements, and a solid tracking system lead 
              not only to successful results but also time saved. From the beginning, we ask the needed questions 
              and begin work immediately to increase efficiencies and provide quick turnaround.
            </p>
            <p>
              Whether you need AI-powered solutions, cloud infrastructure, mobile applications, or top technical talent, 
              we are here to help you navigate the rapidly evolving technology landscape and achieve your business objectives.
            </p>
            <br />
            <br />
            <br />
          </div>
        </div>
        <div style={{ clear: "both" }}></div>
      </main>
    );
  }
}
export default About;
